import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  artisanCategoriesIsLoadingSelector,
  artisanCategoriesListSelector
} from '../../../../modules/artisanJobCategories/Selectors';
import {
  artisanJobByIdSelector,
  artisanJobsIsLoadingSelector
} from '../../../../modules/artisanJobs/Selectors';
import { artisansIsLoadingSelector } from '../../../../modules/artisans/Selectors';
import getLangData from '../../../../utils/getLangData';
import * as Yup from 'yup';
import FormGroup from '../../../../components/form/FormGroup';
import {
  InputField,
  SearchableSelect,
  TextArea,
  Select,
  CheckBox
} from '../../../../components/form';
import SkillsSearchable from '../../../../components/form/SkillsSearchable';
import { getArtisanCategoriesAction } from '../../../../modules/artisanJobCategories/Actions';
import { getArtisanCategories } from '../../../../modules/artisanJobCategories/Api';
import areas from '../../../../assets/areas.json';
import api from '../../../../helpers/api';

const schema = () =>
  Yup.object().shape({
    jobCID: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    salary: Yup.string().default(''),
    jobState: Yup.string().default(''),
    jobTitle: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    jobDescription: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    yearsOfExperience: Yup.number()
      .default(1)
      .positive('must be positive')
      .required(getLangData().fields.required),
    city: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    area: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    trainingAvailable: Yup.boolean().default(false),
    skills: Yup.array()
      .default([])
      .required(getLangData().fields.required)
  });

export const jobStateOptions = [
  {
    label: 'وقت كامل',
    value: 'fullTime'
  },
  {
    label: 'دوام جزائي',
    value: 'partTime'
  },
  {
    label: 'يومي',
    value: 'daily'
  },
  {
    label: 'عمل حر',
    value: 'freelance'
  },
  {
    label: 'موسمي',
    value: 'seasonBased'
  }
];
const JobForm = ({ jobData, toggleModal }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [categoriesIsLoading, setCategoriesIsLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const fieldsLang = getLangData().fields;
  const buttonsLang = getLangData().buttons;

  const getCategories = async payload => {
    const defData = {
      offset: 0,
      size: 50,
      searchTerm: '',
      sort: 'name',
      dir: 'asc',
      filterBy: [{ type: jobData.artisanId ? '1' : '0' }]
    };
    const body = { ...defData, ...payload };
    setCategoriesIsLoading(true);
    try {
      const result = await getArtisanCategories(body);
      setCategories(result.data.content);
    } catch (error) {
    } finally {
      setCategoriesIsLoading(false);
    }
  };
  useEffect(() => {
    getCategories({ searchTerm: '', size: 50 });
  }, []);

  console.log(jobData, 'jobData');
  return (
    <Formik
      initialValues={
        jobData ? { ...jobData, skills: jobData.skills } : schema().cast()
      }
      validationSchema={schema()}
      onSubmit={async values => {
        setIsLoading(true);
        try {
          await api.put(`/job/${jobData._id}`, values);
          toggleModal();
          window.location.reload()

        } catch (error) {
        } finally {
          setIsLoading(false);
        }
      }}
    >
      {({ values, handleSubmit, errors }) => (
        <FormGroup
          errors={errors}
          isLoading={isLoading}
          handleSubmit={handleSubmit}
        // heading={
        //   jobData
        //     ? `${buttonsLang.update} [${jobData.jobTitle}]`
        //     : buttonsLang.create
        // }
        >
          {console.log(values['jobCID'], 'jobData')}
          <SearchableSelect
            name={'jobCID'}
            label={
              jobData.artisanId
                ? getLangData().general_words.artisan_categories
                : getLangData().general_words.supplier_categories
            }
            getItems={getCategories}
            options={categories}
            isLoading={categoriesIsLoading}
            defaultValues={values['jobCID']}
          />
          <InputField label={fieldsLang?.title_job} name='jobTitle' />
          <TextArea
            name='jobDescription'
            label={fieldsLang.descrition_job}
            RTL='rtl'
          />
          <InputField
            label={fieldsLang?.yearsOfExperience}
            name='yearsOfExperience'
            type='number'
          />
          <InputField label={'الراتب'} name='salary' type='text' />
          <Select
            options={jobStateOptions}
            name='jobState'
            label='نوع الوظيفة'
          />
          <CheckBox
            name='trainingAvailable'
            label={fieldsLang.trainingAvailable}
          />
          <SkillsSearchable
            name='skills'
            label={fieldsLang.skills_applicant}
            options={values.skills}
          />
          <Select
            options={Object.keys(areas).map(data => ({
              value: data,
              label: data
            }))}
            name='city'
            label='المدينة'
          />
          {values['city'] && (
            <Select
              options={areas[values['city']]}
              name='area'
              label='المنطقة'
            />
          )}
        </FormGroup>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  return {
    categories: artisanCategoriesListSelector(state),
    categoriesIsLoading: artisanCategoriesIsLoadingSelector(state)
  };
};

export default connect(mapStateToProps, {
  getCategories: getArtisanCategoriesAction
})(JobForm);
